import React from 'react';

import { Grid } from '@sunwisesoftware/sunwise-ui';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';

import {
    CREDIPLATA_UID,
    KAM_UID,
    RED_GIRASOL_UID,
    SERFIMEX_UID,
} from 'common/constants';
import { getFinancierId } from 'common/utils/session';

const Container = () => {
    const financierId = getFinancierId();
    const dispatch = useDispatch();

    const viewMap = {
        [CREDIPLATA_UID]:
            'https://lookerstudio.google.com/embed/reporting/900ae5a9-6ebc-4100-a2e6-24539648be4f/page/p_jqib154dud',
        [KAM_UID]:
            'https://lookerstudio.google.com/embed/reporting/a7508713-4f02-4aa1-a0c0-8098e9185043/page/p_jqib154dud',
        [RED_GIRASOL_UID]:
            'https://lookerstudio.google.com/embed/reporting/249a50e0-51b4-4b2a-ac94-e0f1cd566c8c/page/p_jqib154dud',
        [SERFIMEX_UID]:
            'https://lookerstudio.google.com/embed/reporting/51405e9b-dea0-4cf5-ae12-bf5b9e1c8b5c/page/p_jqib154dud',
    };

    const viewUrl = viewMap[financierId];

    if (!viewUrl) {
        dispatch(push('/'));
        return;
    }

    return (
        <Grid container sx={{ alignItems: 'center', height: '100%' }}>
            <Grid size={18} sx={{ height: '100%' }}>
                <iframe
                    src={viewUrl}
                    style={{
                        border: 0,
                        height: 'calc(100% + 46px)',
                        width: '100%',
                    }}
                />
            </Grid>
        </Grid>
    );
};

export default Container;
